import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-sessao-nao-aberta',
  templateUrl: './sessao-nao-aberta.component.html'
})
export class SessaoNaoAbertaComponent implements OnInit {
  
  constructor(    
  ) { }

  ngOnInit() {


  }

  public atualizar() {
    location.reload();
  }


}
